import React from "react";
import { useNavigate } from "react-router-dom";

const RenewLicensePage = () => {
  const navigate = useNavigate();

  const licensePacks = [
    { name: "Starter", duration: "7 days", price: 35, code: "starter_7" },
    { name: "Premium", duration: "1 month", price: 150, code: "premium_30" },
    { name: "Business", duration: "Lifetime (2 years before renewal)", price: 3600, code: "business_lifetime" }
  ];

  const goToPayment = (pack) => {
    navigate("/payment", { state: pack });
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2>License Expired</h2>
        <p>Your trial has expired. Please choose a license pack to continue using the system.</p>

        <div style={styles.packContainer}>
          {licensePacks.map((pack, index) => (
            <div key={index} style={styles.packCard}>
              <h3>{pack.name}</h3>
              <p>Duration: {pack.duration}</p>
              <p>Price: GHC {pack.price}</p>

              <button
                style={styles.button}
                onClick={() => goToPayment(pack)}
              >
                Renew {pack.name}
              </button>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f3f4f6"
  },
  card: {
    background: "#fff",
    padding: "40px",
    borderRadius: "10px",
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    maxWidth: "600px",
    width: "90%"
  },
  packContainer: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: "20px",
    flexWrap: "wrap",
    gap: "15px"
  },
  packCard: {
    flex: "1 1 150px",
    background: "#f9fafb",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.05)"
  },
  button: {
    marginTop: "15px",
    padding: "10px 20px",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer"
  }
};

export default RenewLicensePage;